import * as React from 'react';

import { FaqTopic } from '../models';
import FaqTopicItem from './FaqTopicItem';

export const FaqTopicItemList: React.SFC<{ faqTopics; selectedFaqTopic; setSelectedFaqTopic }> = (props) => {
  return props.faqTopics.map((faqTopic: FaqTopic, index: number) => (
    <FaqTopicItem
      key={index}
      selectedFaqTopic={props.selectedFaqTopic}
      setSelectedFaqTopic={props.setSelectedFaqTopic}
      {...faqTopic}
    />
  ));
};

export default FaqTopicItemList;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/components/FaqTopicItemList.tsx